import { shoppingCart, validateSCart, patchSignature, patchSimType, patchUnpaidBills, patchSecurityDeposit, getShoppingCartById, updateAndValidateShoppingCart, ChangeOfProcessContextSC } from "../api/api";
import { SequenceManagerAction } from '../actions/SequenceManagerAction';

const ShoppingCartAction = {
    SHOPPING_CART_INVALIDATE : 'SHOPPING_CART_INVALIDATE',
    SHOPPING_CART_CREATE_SUCCESS : 'SHOPPING_CART_CREATE_SUCCESS',
    SHOPPING_CART_CREATE_FAILURE : 'SHOPPING_CART_CREATE_FAILURE',
    SHOPPING_CART_PATCH_SIGNATURE_SUCCESS : 'SHOPPING_CART_PATCH_SIGNATURE_SUCCESS',
    SHOPPING_CART_PATCH_SIGNATURE_FAILURE : 'SHOPPING_CART_PATCH_SIGNATURE_FAILURE',
    SHOPPING_CART_VALIDATION_SUCCESS : 'SHOPPING_CART_VALIDATION_SUCCESS',
    SHOPPING_CART_VALIDATION_FAILURE : 'SHOPPING_CART_VALIDATION_FAILURE',
    SHOPPING_CART_UPDATE_SUCCESS : 'SHOPPING_CART_UPDATE_SUCCESS',
    SHOPPING_CART_UPDATE_FAILURE : 'SHOPPING_CART_UPDATE_FAILURE',
    SHOPPING_CART_PATCH_SIM_TYPE_SUCCESS : 'SHOPPING_CART_PATCH_SIM_TYPE_SUCCESS',
    SHOPPING_CART_PATCH_SIM_TYPE_FAILURE : 'SHOPPING_CART_PATCH_SIM_TYPE_FAILURE',
    SHOPPING_CART_PATCH_UNPAID_BILLS_SUCCESS : 'SHOPPING_CART_PATCH_UNPAID_BILLS_SUCCESS',
    SHOPPING_CART_PATCH_UNPAID_BILLS_FAILURE : 'SHOPPING_CART_PATCH_UNPAID_BILLS_FAILURE',
    SHOPPING_CART_PATCH_SECURITY_DEPOSIT_SUCCESS : 'SHOPPING_CART_PATCH_SECURITY_DEPOSIT_SUCCESS',
    SHOPPING_CART_PATCH_SECURITY_DEPOSIT_FAILURE : 'SHOPPING_CART_PATCH_SECURITY_DEPOSIT_FAILURE',
    UPDATE_VALIDATE_CART_SUCCESS : "UPDATE_VALIDATE_CART_SUCCESS",
    UPDATE_VALIDATE_CART_FAILURE : "UPDATE_VALIDATE_CART_FAILURE",
    SHOPPING_CART_PATCH_UNPAID_BILLS_VERIFIED : 'SHOPPING_CART_PATCH_UNPAID_BILLS_VERIFIED',
    SHOPPING_CART_PATCH_SECURITY_DEPOSIT_VERIFIED : 'SHOPPING_CART_PATCH_SECURITY_DEPOSIT_VERIFIED',
    SHOPPING_CART_PUT_PROCESS_CONTEXT_SUCCESS : 'SHOPPING_CART_PUT_PROCESS_CONTEXT_SUCCESS'
}

const win: any = window
const retryCount = win['AllowedAPIRetryCount'];

let shoppingCartCounter = 0;
let updateValidateCounter = 0;
let getShoppingCartCounter = 0;

const createShoppingCart = () => {
    return function (dispatch: any) {
        shoppingCart()
            .then((response: any) => {
                dispatch({ type: ShoppingCartAction.SHOPPING_CART_CREATE_SUCCESS, payload: response.data });
                dispatch({ type: SequenceManagerAction.CREATE_SHOPPING_CART_COMPLETE, payload: response.data });
                const simType = response?.data?.offerContainer?.[0]?.cartItem?.[0]?.product?.productCharacteristic.filter((st: any) => st?.name === "SIM Type")[0];
                dispatch({ type: SequenceManagerAction.SHOPPING_CART_SIM_TYPE, payload: simType?.value });
            })
            .catch((err) => {
                //Display error
                const config = Object.assign(err?.config, { serviceName: 'createShoppingCart' });
                const error = { ...err, config }

                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++shoppingCartCounter
                    if (shoppingCartCounter < retryCount) {
                        dispatch(createShoppingCart());
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

const patchSignatureShoppingCart = () => {
    return function (dispatch: any) {
        patchSignature().then((response) => {
            dispatch({ type: ShoppingCartAction.SHOPPING_CART_PATCH_SIGNATURE_SUCCESS, payload: response.data });
            dispatch({ type: SequenceManagerAction.SHOPPING_CART_PATCH_SIGNATURE_COMPLETE });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const patchSimTypeShoppingCart = (selectedSimType: string, orderType: string) => {
    return function (dispatch: any) {
        patchSimType(selectedSimType, orderType).then((response) => {
            dispatch({ type: ShoppingCartAction.SHOPPING_CART_PATCH_SIM_TYPE_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const ChangeOfProcessContextForSC = (processContextVal: string) => {
    return function (dispatch: any) {
        ChangeOfProcessContextSC(processContextVal).then((response) => {
            dispatch({ type: ShoppingCartAction.SHOPPING_CART_PUT_PROCESS_CONTEXT_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const patchUnpaidBillsShoppingCart = () => {
    return function (dispatch: any) {
        patchUnpaidBills().then((response) => {
            dispatch({ type: ShoppingCartAction.SHOPPING_CART_PATCH_UNPAID_BILLS_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const patchUnpaidVerified = (isUnpaidPatchDone: any) => {
    return function (dispatch: any) {
        dispatch({ type: ShoppingCartAction.SHOPPING_CART_PATCH_UNPAID_BILLS_VERIFIED, payload: isUnpaidPatchDone });
    }
}

const patchSecurityDepositShoppingCart = () => {
    return function (dispatch: any) {
        patchSecurityDeposit().then((response) => {
            dispatch({ type: ShoppingCartAction.SHOPPING_CART_PATCH_SECURITY_DEPOSIT_SUCCESS, payload: response.data });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const patchSecurityDepositVerified = (isSecurityDepositPatchDone: any) => {
    return function (dispatch: any) {
        dispatch({ type: ShoppingCartAction.SHOPPING_CART_PATCH_SECURITY_DEPOSIT_VERIFIED, payload: isSecurityDepositPatchDone });
    }
}

const validateShoppingCart = () => {
    return function (dispatch: any) {
        validateSCart().then((response) => {
            dispatch({ type: ShoppingCartAction.SHOPPING_CART_VALIDATION_SUCCESS, payload: response.data });
            dispatch({ type: SequenceManagerAction.SHOPPING_CART_VALIDATION_COMPLETE });
        })
            .catch((error) => {
                //Display error
                dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
            })
    }
}

const getShoppingCart = (id: any) => {
    return function (dispatch: any) {
        dispatch({ type: ShoppingCartAction.SHOPPING_CART_INVALIDATE });
        getShoppingCartById(id)
            .then((response) => {
                // getUpdateStatus("GET_SHOPPING_CART", response?.status);
                dispatch({ type: ShoppingCartAction.SHOPPING_CART_UPDATE_SUCCESS, payload: response.data });
                dispatch({ type: SequenceManagerAction.SHOPPING_CART_UPDATE_COMPLETE, payload: response.data });
            })
            .catch((err) => {
                //Display error
                // getUpdateStatus("GET_SHOPPING_CART", err?.response?.status);
                const config = Object.assign(err?.config, { serviceName: 'getShoppingCart' });
                const error = { ...err, config }

                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++getShoppingCartCounter
                    if (getShoppingCartCounter < retryCount) {
                        const scId = error?.config?.url.split("/").pop();
                        dispatch(getShoppingCart(scId));
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

const updateAndValidateShoppingCartById = (id: any, appStateUpdate: boolean = false) => {
    return function (dispatch: any) {
        dispatch({ type: ShoppingCartAction.SHOPPING_CART_INVALIDATE });
        updateAndValidateShoppingCart(id).then((response) => {
            dispatch({ type: ShoppingCartAction.UPDATE_VALIDATE_CART_SUCCESS, payload: response.data });
            if (appStateUpdate) {
                dispatch({ type: SequenceManagerAction.UPDATE_VALIDATE_CART_COMPLETE });
            }
        })
            .catch((error) => {
                //Display error
                if (error?.response?.status) {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                } else {
                    ++updateValidateCounter
                    if (updateValidateCounter < retryCount) {
                        const objData = JSON.parse(error?.config?.data);
                        dispatch(updateAndValidateShoppingCartById(objData?.ShoppingCartId, true));
                    } else {
                        dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                    }
                }
            })
    }
}

export { ShoppingCartAction, createShoppingCart, patchSignatureShoppingCart, patchSimTypeShoppingCart, patchUnpaidBillsShoppingCart, patchSecurityDepositShoppingCart, validateShoppingCart, getShoppingCart, updateAndValidateShoppingCartById, patchUnpaidVerified, patchSecurityDepositVerified, ChangeOfProcessContextForSC };